import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import * as fromTitleRepSelectors from '../../../store/selectors/title-rep.selectors';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'red-contact-card-header',
  standalone: false,
  styleUrls: ['./contact-card-header.component.scss'],
  templateUrl: './contact-card-header.component.html'
})
export class ContactCardHeaderComponent {
  private store = inject(Store);

  contactInfo$: Observable<{
    company: string | null;
    email: string | null;
    firstName: string | null;
    lastName: string | null;
    phone: string | null;
    phoneType: string | null;
    photoUrl: string | null;
  }>;

  constructor() {
    this.contactInfo$ = this.store.pipe(select(fromTitleRepSelectors.selectContactInfo));
  }
}
